import { inject, makeEnvironmentProviders, EnvironmentProviders} from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { VESTA_CONFIG } from '../tokens/vesta-config.token';
import { VestaConfigLoaderService } from '../services/vesta-config-loader.service';

export function provideVesta(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const loader = inject(VestaConfigLoaderService);
      return loader.load();
    }),
    {
      provide: VESTA_CONFIG,
      useFactory: () => inject(VestaConfigLoaderService).getSnapshot()
    }
  ]);
}
